webpackJsonp([11,16],{

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(438)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(444),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(755),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.04b8d3c.png";

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lembrete-senha',
  data: function data() {
    return {
      dialogLembreteSenha: false,
      loading: false,
      email: '',
      formValido: false,
      emailRegras: [function (v) {
        return !!v || 'E-mail em branco';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) || 'E-mail inválido'
        );
      }]
    };
  },

  methods: {

    enviarSenha: function enviarSenha() {
      this.$refs.form.validate();
      if (!this.formValido) {
        return;
      }
      this.loading = true;
      // http://www.condoplaza.com.br/bin/cotacao/envialogin.asp
    }
  }
});

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LembreteSenha__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LembreteSenha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LembreteSenha__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  components: {
    LembreteSenha: __WEBPACK_IMPORTED_MODULE_0__LembreteSenha___default.a
  },
  data: function data() {
    return {
      formValido: false,
      validacao: 0,
      texto: '',
      usuarioRegras: [function (v) {
        return !!v || 'Usuario em branco';
      }, function (v) {
        return v.length < 20 || 'Usuario inválido';
      }],
      senhaRegras: [function (v) {
        return !!v || 'Preencha uma senha';
      }]
    };
  },

  methods: {
    test: function test(event) {
      this.usuari.autofocus = true;
    },
    autenticar: function autenticar(event) {
      var _this = this;

      if (this.$refs.form.validate()) {
        this.$store.dispatch('autenticar', {
          nomeUsuario: this.login,
          senha: this.senha,
          mantemConectado: this.manterLogin
        }).then(function () {
          _this.$router.push('/Painel/Inicio/');
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  },
  computed: {
    loading: function loading() {
      return this.$store.getters.loadingAutenticacao;
    },
    usuario: function usuario() {
      return this.$store.getters.usuario;
    },

    login: {
      get: function get() {
        return this.usuario.login;
      },
      set: function set(value) {
        this.$store.commit('updateLogin', value);
      }
    },
    senha: {
      get: function get() {
        return this.usuario.senha;
      },
      set: function set(value) {
        this.$store.commit('updateSenha', value);
      }
    },
    manterLogin: {
      get: function get() {
        return this.usuario.persistencia;
      },
      set: function set(value) {
        this.$store.commit('updatePersistencia', value);
      }
    }
  },
  mounted: function mounted() {
    window.lazyload();
  }
});

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"LembreteSenha.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".titulo-logo img{width:60px;height:60px;float:left}.titulo-logo h4{width:calc(100% - 60px);color:#a2a2a2;float:left;position:relative;top:7px;left:25px}.custom-loader{-webkit-animation:loader 1s infinite;animation:loader 1s infinite;display:-webkit-box;display:-ms-flexbox;display:flex}.destaque-login{color:#f3fdfe;padding:30px}.destaque-login img{float:left;width:60px}.destaque-login h4{float:left;width:calc(100% - 60px);padding:7px 10px;font-weight:700}.destaque-login h6{padding-top:7px;float:left;width:100%}.font-16px{font-size:16px}.float-l{float:left}@media only screen and (max-width:643px){.cadastro-footer{width:100%;position:fixed;bottom:0;left:0;color:#fff;background-color:#ea1d24;text-align:center;padding:10px}.cadastro-footer a{color:#fff!important;font-weight:700}.cadastro-footer span{display:none}}@-webkit-keyframes loader{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loader{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/login/index.vue"],"names":[],"mappings":"AACA,iBACE,WAAY,AACZ,YAAa,AACb,UAAY,CACb,AACD,gBACE,wBAAyB,AACzB,cAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,QAAS,AACT,SAAW,CACZ,AACD,eACE,qCAAsC,AAC9B,6BAA8B,AACtC,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,gBACE,cAAe,AACf,YAAc,CACf,AACD,oBACE,WAAY,AACZ,UAAY,CACb,AACD,mBACE,WAAY,AACZ,wBAAyB,AACzB,iBAAkB,AAClB,eAAkB,CACnB,AACD,mBACE,gBAAiB,AACjB,WAAY,AACZ,UAAY,CACb,AACD,WACE,cAAgB,CACjB,AACD,SACE,UAAW,CACZ,AACD,yCACA,iBACI,WAAY,AACZ,eAAgB,AAChB,SAAU,AACV,OAAQ,AACR,WAAY,AACZ,yBAA0B,AAC1B,kBAAmB,AACnB,YAAc,CACjB,AACD,mBACI,qBAAsB,AACtB,eAAkB,CACrB,AACD,sBACI,YAAc,CACjB,CACA,AACD,0BACA,GACI,4BAA6B,AACrB,mBAAqB,CAChC,AACD,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,kBACA,GACI,4BAA6B,AACrB,mBAAqB,CAChC,AACD,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA","file":"index.vue","sourcesContent":["\n.titulo-logo img{\n  width: 60px;\n  height: 60px;\n  float: left;\n}\n.titulo-logo h4{\n  width: calc(100% - 60px);\n  color: #a2a2a2;\n  float: left;\n  position: relative;\n  top: 7px;\n  left: 25px;\n}\n.custom-loader {\n  -webkit-animation: loader 1s infinite;\n          animation: loader 1s infinite;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.destaque-login{\n  color: #f3fdfe;\n  padding: 30px;\n}\n.destaque-login img{\n  float: left;\n  width: 60px;\n}\n.destaque-login h4{\n  float: left;\n  width: calc(100% - 60px);\n  padding: 7px 10px;\n  font-weight: bold;\n}\n.destaque-login h6{\n  padding-top: 7px;\n  float: left;\n  width: 100%;\n}\n.font-16px{\n  font-size: 16px;\n}\n.float-l{\n  float: left\n}\n@media only screen and (max-width: 643px){\n.cadastro-footer{\n    width: 100%;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    color: #fff;\n    background-color: #ea1d24;\n    text-align: center;\n    padding: 10px;\n}\n.cadastro-footer a{\n    color: #fff!important;\n    font-weight: bold;\n}\n.cadastro-footer span{\n    display: none;\n}\n}\n@-webkit-keyframes loader {\nfrom {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n}\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes loader {\nfrom {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n}\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(435);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("b70b0ba0", content, true, {});

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(436);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("03626a22", content, true, {});

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(437)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(443),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 443:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "full-width": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.dialogLembreteSenha),
      callback: function($$v) {
        _vm.dialogLembreteSenha = $$v
      },
      expression: "dialogLembreteSenha"
    }
  }, [_c('div', {
    staticClass: "link",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("\n     Não consegue acessar sua conta?\n   ")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Esqueci minha senha")])]), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "name": "form-login",
      "value": "true"
    },
    model: {
      value: (_vm.formValido),
      callback: function($$v) {
        _vm.formValido = $$v
      },
      expression: "formValido"
    }
  }, [_c('v-card-text', [_vm._v("\n        Preencha o campo abaixo com seu e-mail\n        "), _c('v-text-field', {
    attrs: {
      "name": "Email",
      "label": "E-mail",
      "rules": _vm.emailRegras,
      "prepend-icon": "mail_outline",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogLembreteSenha = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.enviarSenha
    },
    nativeOn: {
      "click": function($event) {
        _vm.loader = 'loading'
      }
    }
  }, [_vm._v("\n        Enviar\n        "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "height": "100%",
      "background-color": "#ea1d24"
    },
    attrs: {
      "md6": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('div', [_c('img', {
    staticClass: "lazyload img-responsive",
    attrs: {
      "data-src": "/static/img/img-login.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "destaque-login"
  }, [_c('img', {
    staticClass: "lazyload",
    attrs: {
      "data-src": "/static/img/icone-cadastro.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Conquiste!")]), _vm._v(" "), _c('h6', [_vm._v("Venda mais para Condomínios! Conheça a ferramenta que coloca sua empresa em contato com quem compra!")])])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": "",
      "sm6": "",
      "offset-sm3": "",
      "grid-list-xs": "",
      "pt-5": ""
    }
  }, [_c('div', {
    staticClass: "titulo-logo mb-4 float-l"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(404),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("CondoPlaza")])]), _vm._v(" "), _c('v-form', {
    ref: "form",
    staticClass: "mt-5"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "s12": "",
      "offset-s1": "",
      "grid-list-xs": "",
      "pt-5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Usuário",
      "rules": _vm.usuarioRegras,
      "prepend-icon": "person",
      "validate-on-blur": "",
      "required": ""
    },
    model: {
      value: (_vm.login),
      callback: function($$v) {
        _vm.login = $$v
      },
      expression: "login"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "senha",
      "label": "Senha",
      "type": "password",
      "validate-on-blur": "",
      "rules": _vm.senhaRegras,
      "prepend-icon": "lock_open",
      "required": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.autenticar($event)
      }
    },
    model: {
      value: (_vm.senha),
      callback: function($$v) {
        _vm.senha = $$v
      },
      expression: "senha"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Mantenha-me conectado",
      "color": "teal darken-1"
    },
    model: {
      value: (_vm.manterLogin),
      callback: function($$v) {
        _vm.manterLogin = $$v
      },
      expression: "manterLogin"
    }
  }, [_vm._v("\n              entre aequi\n              "), _c('div', {
    staticClass: "link"
  }, [_c('router-link', {
    attrs: {
      "to": "/hello"
    }
  }, [_vm._v("Não consigo acessar minha conta!")])], 1)]), _vm._v(" "), _c('div', {}, [_c('v-btn', {
    staticClass: "btn-green",
    attrs: {
      "round": "",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.autenticar
    },
    nativeOn: {
      "click": function($event) {
        _vm.loader = 'loading'
      }
    }
  }, [_vm._v("\n                Entrar\n                "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "font-16px"
  }, [_c('LembreteSenha')], 1), _vm._v(" "), _c('div', {
    staticClass: "font-16px cadastro-footer"
  }, [_vm._v("\n             Não tem uma conta"), _c('span', [_vm._v(" CondoPlaza")]), _vm._v("? "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/Cadastro"
    }
  }, [_vm._v("Cadastre-se")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__login___ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__login____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__login___);
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'Login': __WEBPACK_IMPORTED_MODULE_0__login____default.a
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$store.commit('toastr', {
      color: 'error',
      texto: 'Sessão expirada'
    });
  }
});

/***/ }),

/***/ 755:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('login')
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.c68d69bf78362702b93a.js